import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey = 'brand_leads-schedule_a_call-click';

/**
 * Parameter indicates which of the schedule a call buttons the user clicked. Should be one of the following: "top-section", "sticky-banner", "bottom-section"
 */
export function trackBrandLeadsScheduleACallClick(
  customParameterToken: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: true,
    parameters: { customParameterToken },
  });
}
